export enum OptionActivation {
  UNKNOW = 'UNKNOW',
  DESACTIVE = 'DESACTIVE',
  ACTIVE = 'ACTIVE',
}
